import { collection, CollectionReference } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { collectionData } from 'rxfire/firestore';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ITag, IUser } from '../types';
import { authenticatedUserProvider } from './userProvider';

const rxTags$: BehaviorSubject<ITag[]> = new BehaviorSubject([]);

/**
 * @description observable of an orgs tags collection
 * @param user {IUser} logged in user
 * @returns {Observable<ITag[]>}
 */
const tagsCollection = (user: IUser): Observable<ITag[]> => {
  if (isEmpty(user)) return EMPTY;
  return collectionData(
    collection(
      user.services.firestore,
      `orgs/${user.orgId}/tags`
    ) as CollectionReference<ITag>,
    { idField: 'id' }
  ).pipe(
    map((tags: ITag[]): ITag[] => {
      /// sort tags alphabetically
      return sortBy(tags, (tag: ITag): string => tag.name.toLowerCase());
    })
  );
};

authenticatedUserProvider().pipe(switchMap(tagsCollection)).subscribe(rxTags$);

/**
 * @description provides hot observable of tags
 */
export const tagsProvider = (): Observable<ITag[]> => {
  return rxTags$;
};
